// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2ff95ec4","598":"9a3afc56","703":"75b18a87","787":"7407c96f"}[chunkId] + ".chunk.js";
};